module.exports = __webpack_public_path__ + "static/media/grataCanisMajorLogo.d17f89eb.jpg";